<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>

        <div class="card">
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{ 'label.novo' | translate }}" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="openNew()" *ngIf="perfilCont != null && perfilCont.nmePerfil === 'ADMTIVIT'"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button pButton pRipple label="{{ 'label.exportar' | translate }}" icon="pi pi-upload" class="p-button-help p-mb-2" (click)="dt.exportCSV()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt [value]="perfis" [columns]="cols" [rows]="10" [paginator]="true" [globalFilterFields]="['codPerfil','dscPerfil','nmePerfil']"
                     [(selection)]="selectedPerfis" [rowHover]="true" dataKey="id"
                     styleClass="p-datatable-customers"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5 class="p-m-0">{{ 'perfil.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                    </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="codPerfil">{{ 'perfil.codigo' | translate }} <p-sortIcon field="codPerfil"></p-sortIcon></th>
						<th pSortableColumn="dscPerfil">{{ 'perfil.descricao' | translate }}<p-sortIcon field="dscPerfil"></p-sortIcon></th>
						<th pSortableColumn="nmePerfil">{{ 'perfil.nome' | translate }}<p-sortIcon field="nmePerfil"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-perfil>
                    <tr>
                        <td><span class="p-column-title" style="text-align: center;">Codigo Perfil</span>
                            {{perfil.codPerfil}}
                        </td>
                        <td><span class="p-column-title" style="text-align: center;">Descricao Perfil</span>
                            {{perfil.dscPerfil}}
												</td>
												<td><span class="p-column-title" style="text-align: center;">Nome Perfil</span>
                            {{perfil.nmePerfil}}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editPerfil(perfil)" *ngIf="perfilCont != null && perfilCont.nmePerfil === 'ADMTIVIT'"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deletePerfil(perfil)" *ngIf="perfilCont != null && perfilCont.nmePerfil === 'ADMTIVIT'"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ 'label.totalde' | translate }} {{perfis ? perfis.length : 0 }} {{ 'perfil.perfis' | translate }}
                    </div>
                </ng-template>
            </p-table>
        </div>

        <p-dialog [(visible)]="perfilDialog" [style]="{width: '450px'}" header="{{ 'perfil.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="name">{{ 'perfil.descricao' | translate }}</label>
                    <input type="text" pInputText id="nmePerfil" [(ngModel)]="perfil.dscPerfil" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !perfil.dscPerfil">Descricao do perfil obrigatorio.</small>
                </div>
                <div class="p-field">
                    <label for="name">{{ 'perfil.nome' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="perfil.nmePerfil" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !perfil.nmePerfil">Nome do do perfil obrigatorio.</small>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.salvar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="savePerfil()"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>
